import { makeStyles } from "@material-ui/core";

const MuiStylesProfessionalDiv = makeStyles((theme) => ({
	avatar: {
		height: "60px",
		width: "60px",
	},
	header: {
		flex: 1,
		height: "123px",
	},
	title: {
		fontWeight: 400,
		color: "#474747",
		fontSize: "16px",
		lineHeight: 1,
		letterSpacing: "-0.36px",
	},
	subtitle: {
		fontWeight: 400,
		color: "rgba(71,71,71,0.5)",
		fontSize: "14px",
		lineHeight: 1,
		letterSpacing: "-0.31px",
		marginTop: "7px",
	},
	price: {
		fontWeight: 400,
		color: "rgb(60, 60, 60)",
		fontSize: "14px",
		lineHeight: 1,
		letterSpacing: "-0.31px",
		opacity: 0.9
	},
	titleWithoutBackground: {
		color: "#474747",
	},
	iconButton: {
		backgroundColor: "#ffffff",
	},
	iconButtonSvg: {
		fill: "#630094",
	},
	time: {
		fontSize: "clamp(16px, 1vw, 18px)",
		fontWeight: "bold",
		alignSelf: "center",
		color: "rgb(60, 60, 60)",
		letterSpacing: "-0.31px",
		opacity: 0.9
	},
}));

export default MuiStylesProfessionalDiv;
